// removed by extract-text-webpack-plugin
module.exports = {"buttonLink":"buttonLink___2x72s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/resultsPane/styles.module.scss
// module id = 1613
// module chunks = 0